const getTruMediaHeatmapGradient = () => [
  {
    minVal: 0,
    minColor: [13, 0, 255],
    maxVal: 0.357,
    maxColor: [35, 255, 231],
  },
  {
    minVal: 0.357,
    minColor: [35, 255, 231],
    maxVal: 0.5,
    maxColor: [34, 255, 10],
  },
  {
    minVal: 0.5,
    minColor: [34, 255, 10],
    maxVal: 0.643,
    maxColor: [255, 255, 10],
  },
  {
    minVal: 0.643,
    minColor: [255, 255, 10],
    maxVal: 1,
    maxColor: [252, 0, 5],
  },
];

const getRedWhiteGreenGradient = () => [
  {
    minVal: 0,
    minColor: [233, 143, 143],
    maxVal: 0.5,
    maxColor: [255, 255, 255],
  },
  {
    minVal: 0.5,
    minColor: [255, 255, 255],
    maxVal: 1,
    maxColor: [62, 188, 94],
  },
];

const getGreenWhiteRedGradient = () => [
  {
    minVal: 0,
    minColor: [62, 188, 94],
    maxVal: 0.5,
    maxColor: [255, 255, 255],
  },
  {
    minVal: 0.5,
    minColor: [255, 255, 255],
    maxVal: 1,
    maxColor: [233, 143, 143],
  },
];

const getRankGradient = () => [
  {
    minVal: 1,
    minColor: [62, 188, 94],
    maxVal: 15,
    maxColor: [255, 255, 255],
  },
  {
    minVal: 15,
    minColor: [255, 255, 255],
    maxVal: 30,
    maxColor: [233, 143, 143],
  },
];

const getBrownWhiteBlueGradient = () => [
  {
    minVal: 0,
    minColor: '#853C00',
    maxVal: 0.5,
    maxColor: [255, 255, 255],
  },
  {
    minVal: 0.5,
    minColor: [255, 255, 255],
    maxVal: 1,
    maxColor: '#004985',
  },
];

const getWhiteToRedGradient = () => [
  {
    minColor: [255, 255, 255],
    minVal: 0,
    maxColor: [233, 143, 143],
    maxVal: 1,
  },
];

const getWhiteToGreenGradient = () => [
  {
    minColor: [255, 255, 255],
    minVal: 0,
    maxColor: [142, 210, 142],
    maxVal: 1,
  },
];

// GGPlot gradient
const getBlueWhiteRedGradient = () => [
  {
    minVal: 0,
    minColor: '#3A3A98', //[31, 73, 125],
    maxVal: 0.5,
    maxColor: [255, 255, 255],
  },
  {
    minVal: 0.5,
    minColor: [255, 255, 255],
    maxVal: 1,
    maxColor: '#832424', //[145, 53, 51],
  },
];

const getRedWhiteBlueGradient = () => [
  {
    minVal: 0,
    minColor: '#832424', //[31, 73, 125],
    maxVal: 0.5,
    maxColor: [255, 255, 255],
  },
  {
    minVal: 0.5,
    minColor: [255, 255, 255],
    maxVal: 1,
    maxColor: '#3A3A98', //[145, 53, 51],
  },
];

export {
  getTruMediaHeatmapGradient,
  getRedWhiteGreenGradient,
  getGreenWhiteRedGradient,
  getRankGradient,
  getWhiteToRedGradient,
  getBlueWhiteRedGradient,
  getRedWhiteBlueGradient,
  getBrownWhiteBlueGradient,
  getWhiteToGreenGradient,
};
